import { useEffect, useState } from 'react';
import Icon from './Icons';
import { linkWhatsApp } from '../config';
import './BotoesFlutuantes.css';

export default function BotoesFlutuantes() {
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    const aoRolar = () => setVisivel(window.scrollY > 520);
    aoRolar();
    window.addEventListener('scroll', aoRolar, { passive: true });
    return () => window.removeEventListener('scroll', aoRolar);
  }, []);

  const subir = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className={`flutuantes ${visivel ? 'flutuantes--visivel' : ''}`}>
      <button
        type="button"
        className="flutuante flutuante--topo"
        onClick={subir}
        aria-label="Voltar ao topo da página"
      >
        <Icon name="chevron" size={22} />
      </button>

      <a
        className="flutuante flutuante--whatsapp"
        href={linkWhatsApp()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Conversar pelo WhatsApp"
      >
        <Icon name="whatsapp" size={26} />
        <span>Fale conosco</span>
      </a>
    </div>
  );
}
